<template>
  <div>
    <button
      type="button"
      class="focus:outline-none text-indigo-600 hover:text-indigo-900"
      @click="showAccProduct"
    >
      View
    </button>
  </div>
</template>

<script>
export default {
  inject: ['fetchProducts'],
  props: {
    accProductId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    showAccProduct() {
      this.$modal.show({
        component: () => import('@/components/AccProductModal/Index.vue'),
        props: {
          accProductId: this.accProductId,
        },
        on: {
          updated: (id) => {
            this.$emit('updated', id);
          },
          destroyed: () => {
            this.fetchProducts();
          },
        },
        hideEvent: 'hide',
      });
    },
    setShow(show = true) {
      this.show = show;
    },
    closeModal() {
      this.setShow(false);
    },
  },
};
</script>
